const routes = [
  {
    path: 'access',
    component: () => import(/* webpackChunkName: "access" */ '@/modules/access/index.vue'),
    children: [
      {
        path: '',
        name: 'access',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/access/demo1.vue'),
      },
      {
        path: 'demo1',
        component: () => import(/* webpackChunkName: "demo1" */ '@/modules/access/demo1.vue'),
      },
      {
        path: 'demo2',
        component: () => import(/* webpackChunkName: "demo2" */ '@/modules/access/demo2.vue'),
      },
    ],
  },
];

export default routes;